module.exports = __webpack_public_path__ + "img/icon2.1076d273.webp";